import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app";
import "./index.css";

/**
 * 開発モードでMSWを有効化する
 */
async function enableMocking(): Promise<void> {
  if (import.meta.env.DEV && import.meta.env.VITE_ENABLE_MOCKING === "true") {
    const { worker } = await import("./api/mocks/browser");
    await worker.start({
      onUnhandledRequest: "bypass",
    });
  }
}

/**
 * アプリケーションを初期化してレンダリングする
 */
async function main(): Promise<void> {
  await enableMocking();

  const rootElement = document.getElementById("root");
  if (!rootElement) {
    throw new Error("ルート要素が見つかりません");
  }

  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}

main().catch(console.error);
